import axios, { AxiosError } from "axios";

// Single axios instance with a JWT interceptor. The token lives in memory
// only — initData re-validates on every refresh so a refresh resets the
// session, which is desirable for a Mini-App.
let bearerToken: string | null = null;

export function setBearerToken(token: string | null) {
  bearerToken = token;
}

export const api = axios.create({
  baseURL: "/api",
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  if (bearerToken) {
    config.headers.Authorization = `Bearer ${bearerToken}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      bearerToken = null;
    }
    return Promise.reject(error);
  },
);
